// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Layout */
.attendance-records-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: var(--gray-50);
  margin-top: 50px;
}

.main-content {
  display: flex;
  flex: 1 1;
}

.attendance-records-content {
  flex: 1 1;
  padding: 2rem;
  display: flex;
  justify-content: center;
}

/* Attendance Card */
.attendance-records-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  width: 100%;
  max-width: 800px;
  background-color: #ffffff;
}

.attendance-records-title {
  color: var(--gray-800);
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
  text-align: center;
  font-weight: 600;
}

/* Filters */
.filters-container {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.filter-label {
  font-weight: 500;
  color: var(--gray-600);
}

.filter-select {
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--gray-200);
  border-radius: 6px;
  background-color: white;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s;
  background-color: var(--gray-50);
}

.filter-select:hover {
  border-color: var(--gray-300);
  background-color: #ffffff;
}

/* Calendar - Fixed Numbers Overflow */
.calendar-wrapper {
  margin: 1.5rem 0;
  width: 100%;
  overflow: hidden;
   

}

.react-calendar {
  width: 100% !important;
  max-width: 100%;
  background: white;
  border: none; /* ✅ This removes the border */
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  font-family: inherit;
  line-height: 1.125em;
  padding: 20px;
  padding-top: 15px;
  padding-bottom: 10px;
}



.react-calendar__navigation {
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
}

.react-calendar__navigation button {
  background: none;
  border: none;
  font-size: 1rem;
  font-weight: 600;
  color: var(--gray-800);
  min-width: 44px;
  padding: 0.5rem;
  cursor: pointer;
  transition: all 0.2s;
}

.react-calendar__navigation button:hover {
  background-color: var(--gray-200);
  border-radius: 6px;
}

.react-calendar__navigation button:disabled {
  background-color: transparent;
  color: #a0aec0;
}

.react-calendar__month-view__weekdays {
  text-align: center;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 0.75rem;
  color: var(--gray-600);
  margin-bottom: 0.5rem;
}

.react-calendar__month-view__weekdays__weekday {
  padding: 0.5em;
}

.react-calendar__month-view__weekdays__weekday abbr {
  text-decoration: none;
}

.react-calendar__month-view__days {
  display: grid !important;
  grid-template-columns: repeat(7, 1fr);
  gap: 5px;
}

.react-calendar__month-view__days__day {
  max-width: initial !important;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  border-radius: 15px;
  font-size: 0.9rem;
  transition: all 0.2s;
}

.react-calendar__tile--now {
  background: #ebf8ff;
  color: #3182ce;
  font-weight: bold;
}

.react-calendar__tile--now:hover {
  background: #bee3f8;
}

.react-calendar__tile--active {
  background: #3182ce !important;
  color: white !important;
  font-weight: bold;
}

.react-calendar__tile--active:hover {
  background: #2c5282 !important;
}

.present-date {
  background-color: #f0fff4;
  color: #38a169;
  font-weight: 500;
}

.present-date:hover {
  background-color: #c6f6d5;
}

.absent-date {
  background-color: #fff5f5;
  color: #e53e3e;
}

.absent-date:hover {
  background-color: #fed7d7;
}

.future-date {
  color: #a0aec0;
  background-color: var(--gray-50);
}

.react-calendar__tile:disabled {
  background-color: var(--gray-50);
  color: #cbd5e0;
}

/* Attendance Details */
.attendance-details-card {
  margin-top: 2rem;
  padding: 1.5rem;
  background-color: var(--gray-50);
  border-radius: 8px;
  border-left: 4px solid var(--primary-500);
}

.details-title {
  color: var(--gray-800);
  font-size: 1.3rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.detail-row {
  display: flex;
  margin-bottom: 0.75rem;
  flex-wrap: wrap;
}

.detail-label {
  font-weight: 600;
  color: var(--gray-600);
  min-width: 140px;
}

.detail-value {
  color: var(--gray-800);
  flex: 1 1;
}

/* Messages */
.error-message {
  color: #e53e3e;
  text-align: center;
  margin: 1rem 0;
  font-weight: 500;
  padding: 0.75rem;
  background-color: #fff5f5;
  border-radius: 6px;
}

.no-records-message,
.select-date-message {
  text-align: center;
  color: var(--gray-500);
  margin: 1.5rem 0;
  font-style: italic;
  padding: 0.75rem;
  background-color: var(--gray-50);
  border-radius: 6px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .main-content {
    flex-direction: column;
  }

  .attendance-records-content {
    padding: 1rem;
  }

  .filters-container {
    flex-direction: column;
    gap: 1rem;
  }

  .filter-group {
    width: 100%;
  }

  .filter-select {
    flex: 1 1;
  }

  .react-calendar__month-view__days__day {
    height: 32px;
    font-size: 0.85rem;
  }
}

@media (max-width: 480px) {
  .attendance-records-card {
    padding: 1.25rem;
  }

  .attendance-records-title {
    font-size: 1.5rem;
  }

  .detail-row {
    flex-direction: column;
    gap: 0.25rem;
  }

  .detail-label {
    min-width: 100%;
  }

  .react-calendar__navigation button {
    min-width: 36px;
    padding: 0.25rem;
    font-size: 0.9rem;
  }
}

/* Calendar Numbers Fix */
.react-calendar__month-view__days {
  display: grid !important;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 2px;
}

.react-calendar__month-view__days__day {
  height: 32px !important;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  font-size: 0.8rem !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.react-calendar__month-view__weekdays {
  font-size: 0.7rem !important;
}

/* For smaller screens */
@media (max-width: 480px) {
  .react-calendar__month-view__days__day {
    height: 28px !important;
    font-size: 0.7rem !important;
  }

  .react-calendar {
    padding: 0.5rem !important;
  }
}



























.react-calendar__month-view__weekdays {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0.75em;
}

.react-calendar__month-view__days__day--weekend {
  color: #d10000;
}

.react-calendar__tile--now {
  background: #ffff76;
}

.react-calendar__tile--active {
  background: #006edc;
  color: white;
}

.present-date {
  background-color: var(--success);
  color: white;
}

.absent-date {
  background-color: #eb6359;
  color: white;
}

.future-date {
  background-color: var(--gray-200);
  color: #757575;
}















/* Hide neighboring month dates */
.react-calendar__month-view__days__day--neighboringMonth {
  visibility: hidden;
  pointer-events: none;
}

/* Ensure the calendar grid maintains its structure */
.react-calendar__month-view__days {
  display: grid !important;
  grid-template-columns: repeat(7, 1fr);
}

/* Style for future dates */
.future-date {
  background-color: var(--gray-50);
  color: #ccc;
}

/* Style for present dates (with attendance) */
.present-date {
  background-color: #d4edda;
  color: #155724;
}

/* Style for absent dates */
.absent-date {
  background-color: #f8d7da;
  color: #721c24;
}

/* Style for the current date */
.react-calendar__tile--now {
  background-color: #e6f7ff; /* current date highlight */
  border: 1px solid #1890ff !important;
}


.sunday-date {
  background-color: #fffacd; /* Light yellow background */
  color: #000; /* Black text for better contrast */
}

/* Optional: Add hover effect for better UX */
.sunday-date:hover {
  background-color: #fff380;
}`, "",{"version":3,"sources":["webpack://./src/components/Attendence/GetMyAttendance.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAO;AACT;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;;;AAGlB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,YAAY,EAAE,8BAA8B;EAC5C,mBAAmB;EACnB,0CAA0C;EAC1C,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,iBAAiB;EACjB,oBAAoB;AACtB;;;;AAIA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,SAAO;AACT;;AAEA,aAAa;AACb;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA,yBAAyB;AACzB;EACE,wBAAwB;EACxB,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,wBAAwB;AACxB;EACE;IACE,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;;;;;;;;;;;;;;;;;;;;;;;;;;;AA4BA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;;;;;;;;;;;;;;;AAgBA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,qDAAqD;AACrD;EACE,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA,2BAA2B;AAC3B;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA,8CAA8C;AAC9C;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB,EAAE,2BAA2B;EACtD,oCAAoC;AACtC;;;AAGA;EACE,yBAAyB,EAAE,4BAA4B;EACvD,WAAW,EAAE,mCAAmC;AAClD;;AAEA,6CAA6C;AAC7C;EACE,yBAAyB;AAC3B","sourcesContent":["/* Main Layout */\n.attendance-records-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background-color: var(--gray-50);\n  margin-top: 50px;\n}\n\n.main-content {\n  display: flex;\n  flex: 1;\n}\n\n.attendance-records-content {\n  flex: 1;\n  padding: 2rem;\n  display: flex;\n  justify-content: center;\n}\n\n/* Attendance Card */\n.attendance-records-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  padding: 2rem;\n  width: 100%;\n  max-width: 800px;\n  background-color: #ffffff;\n}\n\n.attendance-records-title {\n  color: var(--gray-800);\n  font-size: 1.8rem;\n  margin-bottom: 1.5rem;\n  text-align: center;\n  font-weight: 600;\n}\n\n/* Filters */\n.filters-container {\n  display: flex;\n  gap: 1.5rem;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n}\n\n.filter-group {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.filter-label {\n  font-weight: 500;\n  color: var(--gray-600);\n}\n\n.filter-select {\n  padding: 0.5rem 0.75rem;\n  border: 1px solid var(--gray-200);\n  border-radius: 6px;\n  background-color: white;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s;\n  background-color: var(--gray-50);\n}\n\n.filter-select:hover {\n  border-color: var(--gray-300);\n  background-color: #ffffff;\n}\n\n/* Calendar - Fixed Numbers Overflow */\n.calendar-wrapper {\n  margin: 1.5rem 0;\n  width: 100%;\n  overflow: hidden;\n   \n\n}\n\n.react-calendar {\n  width: 100% !important;\n  max-width: 100%;\n  background: white;\n  border: none; /* ✅ This removes the border */\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  font-family: inherit;\n  line-height: 1.125em;\n  padding: 20px;\n  padding-top: 15px;\n  padding-bottom: 10px;\n}\n\n\n\n.react-calendar__navigation {\n  margin-bottom: 1rem;\n  display: flex;\n  justify-content: space-between;\n}\n\n.react-calendar__navigation button {\n  background: none;\n  border: none;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--gray-800);\n  min-width: 44px;\n  padding: 0.5rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.react-calendar__navigation button:hover {\n  background-color: var(--gray-200);\n  border-radius: 6px;\n}\n\n.react-calendar__navigation button:disabled {\n  background-color: transparent;\n  color: #a0aec0;\n}\n\n.react-calendar__month-view__weekdays {\n  text-align: center;\n  text-transform: uppercase;\n  font-weight: 600;\n  font-size: 0.75rem;\n  color: var(--gray-600);\n  margin-bottom: 0.5rem;\n}\n\n.react-calendar__month-view__weekdays__weekday {\n  padding: 0.5em;\n}\n\n.react-calendar__month-view__weekdays__weekday abbr {\n  text-decoration: none;\n}\n\n.react-calendar__month-view__days {\n  display: grid !important;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 5px;\n}\n\n.react-calendar__month-view__days__day {\n  max-width: initial !important;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  margin: 0;\n  border-radius: 15px;\n  font-size: 0.9rem;\n  transition: all 0.2s;\n}\n\n.react-calendar__tile--now {\n  background: #ebf8ff;\n  color: #3182ce;\n  font-weight: bold;\n}\n\n.react-calendar__tile--now:hover {\n  background: #bee3f8;\n}\n\n.react-calendar__tile--active {\n  background: #3182ce !important;\n  color: white !important;\n  font-weight: bold;\n}\n\n.react-calendar__tile--active:hover {\n  background: #2c5282 !important;\n}\n\n.present-date {\n  background-color: #f0fff4;\n  color: #38a169;\n  font-weight: 500;\n}\n\n.present-date:hover {\n  background-color: #c6f6d5;\n}\n\n.absent-date {\n  background-color: #fff5f5;\n  color: #e53e3e;\n}\n\n.absent-date:hover {\n  background-color: #fed7d7;\n}\n\n.future-date {\n  color: #a0aec0;\n  background-color: var(--gray-50);\n}\n\n.react-calendar__tile:disabled {\n  background-color: var(--gray-50);\n  color: #cbd5e0;\n}\n\n/* Attendance Details */\n.attendance-details-card {\n  margin-top: 2rem;\n  padding: 1.5rem;\n  background-color: var(--gray-50);\n  border-radius: 8px;\n  border-left: 4px solid var(--primary-500);\n}\n\n.details-title {\n  color: var(--gray-800);\n  font-size: 1.3rem;\n  margin-bottom: 1rem;\n  font-weight: 600;\n}\n\n.detail-row {\n  display: flex;\n  margin-bottom: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.detail-label {\n  font-weight: 600;\n  color: var(--gray-600);\n  min-width: 140px;\n}\n\n.detail-value {\n  color: var(--gray-800);\n  flex: 1;\n}\n\n/* Messages */\n.error-message {\n  color: #e53e3e;\n  text-align: center;\n  margin: 1rem 0;\n  font-weight: 500;\n  padding: 0.75rem;\n  background-color: #fff5f5;\n  border-radius: 6px;\n}\n\n.no-records-message,\n.select-date-message {\n  text-align: center;\n  color: var(--gray-500);\n  margin: 1.5rem 0;\n  font-style: italic;\n  padding: 0.75rem;\n  background-color: var(--gray-50);\n  border-radius: 6px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .main-content {\n    flex-direction: column;\n  }\n\n  .attendance-records-content {\n    padding: 1rem;\n  }\n\n  .filters-container {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .filter-group {\n    width: 100%;\n  }\n\n  .filter-select {\n    flex: 1;\n  }\n\n  .react-calendar__month-view__days__day {\n    height: 32px;\n    font-size: 0.85rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .attendance-records-card {\n    padding: 1.25rem;\n  }\n\n  .attendance-records-title {\n    font-size: 1.5rem;\n  }\n\n  .detail-row {\n    flex-direction: column;\n    gap: 0.25rem;\n  }\n\n  .detail-label {\n    min-width: 100%;\n  }\n\n  .react-calendar__navigation button {\n    min-width: 36px;\n    padding: 0.25rem;\n    font-size: 0.9rem;\n  }\n}\n\n/* Calendar Numbers Fix */\n.react-calendar__month-view__days {\n  display: grid !important;\n  grid-template-columns: repeat(7, minmax(0, 1fr));\n  gap: 2px;\n}\n\n.react-calendar__month-view__days__day {\n  height: 32px !important;\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  font-size: 0.8rem !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.react-calendar__month-view__weekdays {\n  font-size: 0.7rem !important;\n}\n\n/* For smaller screens */\n@media (max-width: 480px) {\n  .react-calendar__month-view__days__day {\n    height: 28px !important;\n    font-size: 0.7rem !important;\n  }\n\n  .react-calendar {\n    padding: 0.5rem !important;\n  }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.react-calendar__month-view__weekdays {\n  text-align: center;\n  text-transform: uppercase;\n  font-weight: bold;\n  font-size: 0.75em;\n}\n\n.react-calendar__month-view__days__day--weekend {\n  color: #d10000;\n}\n\n.react-calendar__tile--now {\n  background: #ffff76;\n}\n\n.react-calendar__tile--active {\n  background: #006edc;\n  color: white;\n}\n\n.present-date {\n  background-color: var(--success);\n  color: white;\n}\n\n.absent-date {\n  background-color: #eb6359;\n  color: white;\n}\n\n.future-date {\n  background-color: var(--gray-200);\n  color: #757575;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* Hide neighboring month dates */\n.react-calendar__month-view__days__day--neighboringMonth {\n  visibility: hidden;\n  pointer-events: none;\n}\n\n/* Ensure the calendar grid maintains its structure */\n.react-calendar__month-view__days {\n  display: grid !important;\n  grid-template-columns: repeat(7, 1fr);\n}\n\n/* Style for future dates */\n.future-date {\n  background-color: var(--gray-50);\n  color: #ccc;\n}\n\n/* Style for present dates (with attendance) */\n.present-date {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n/* Style for absent dates */\n.absent-date {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n/* Style for the current date */\n.react-calendar__tile--now {\n  background-color: #e6f7ff; /* current date highlight */\n  border: 1px solid #1890ff !important;\n}\n\n\n.sunday-date {\n  background-color: #fffacd; /* Light yellow background */\n  color: #000; /* Black text for better contrast */\n}\n\n/* Optional: Add hover effect for better UX */\n.sunday-date:hover {\n  background-color: #fff380;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
